import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IDeployment } from 'app/shared/model/deployment.model';
import { getEntity, updateEntity, createEntity, reset } from './deployment.reducer';

export const DeploymentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const deploymentEntity = useAppSelector(state => state.deployment.entity);
  const loading = useAppSelector(state => state.deployment.loading);
  const updating = useAppSelector(state => state.deployment.updating);
  const updateSuccess = useAppSelector(state => state.deployment.updateSuccess);

  const handleClose = () => {
    navigate('/deployment' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.createdDate = convertDateTimeToServer(values.createdDate);
    values.lastModifiedDate = convertDateTimeToServer(values.lastModifiedDate);

    const entity = {
      ...deploymentEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdDate: displayDefaultDateTime(),
          lastModifiedDate: displayDefaultDateTime(),
        }
      : {
          ...deploymentEntity,
          createdDate: convertDateTimeFromServer(deploymentEntity.createdDate),
          lastModifiedDate: convertDateTimeFromServer(deploymentEntity.lastModifiedDate),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="integrawebApp.deployment.home.createOrEditLabel" data-cy="DeploymentCreateUpdateHeading">
            <Translate contentKey="integrawebApp.deployment.home.createOrEditLabel">Create or edit a Deployment</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="deployment-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('integrawebApp.deployment.tripName')}
                id="deployment-tripName"
                name="tripName"
                data-cy="tripName"
                type="text"
                validate={{
                  maxLength: { value: 40, message: translate('entity.validation.maxlength', { max: 40 }) },
                }}
              />
              <ValidatedField
                label={translate('integrawebApp.deployment.recordStatus')}
                id="deployment-recordStatus"
                name="recordStatus"
                data-cy="recordStatus"
                type="text"
                validate={{
                  maxLength: { value: 1, message: translate('entity.validation.maxlength', { max: 1 }) },
                }}
              />
              <ValidatedField
                label={translate('integrawebApp.deployment.createdDate')}
                id="deployment-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('integrawebApp.deployment.createdBy')}
                id="deployment-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
                validate={{
                  maxLength: { value: 4, message: translate('entity.validation.maxlength', { max: 4 }) },
                }}
              />
              <ValidatedField
                label={translate('integrawebApp.deployment.lastModifiedDate')}
                id="deployment-lastModifiedDate"
                name="lastModifiedDate"
                data-cy="lastModifiedDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('integrawebApp.deployment.lastModifiedBy')}
                id="deployment-lastModifiedBy"
                name="lastModifiedBy"
                data-cy="lastModifiedBy"
                type="text"
                validate={{
                  maxLength: { value: 4, message: translate('entity.validation.maxlength', { max: 4 }) },
                }}
              />
              <ValidatedField
                label={translate('integrawebApp.deployment.deliveryDateFrom')}
                id="deployment-deliveryDateFrom"
                name="deliveryDateFrom"
                data-cy="deliveryDateFrom"
                type="date"
              />
              <ValidatedField
                label={translate('integrawebApp.deployment.deliveryDateTil')}
                id="deployment-deliveryDateTil"
                name="deliveryDateTil"
                data-cy="deliveryDateTil"
                type="date"
              />
              <ValidatedField
                label={translate('integrawebApp.deployment.nrbsFrom')}
                id="deployment-nrbsFrom"
                name="nrbsFrom"
                data-cy="nrbsFrom"
                type="text"
              />
              <ValidatedField
                label={translate('integrawebApp.deployment.nrbsTil')}
                id="deployment-nrbsTil"
                name="nrbsTil"
                data-cy="nrbsTil"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/deployment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DeploymentUpdate;
